(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/views/content/activesuspensions.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/views/content/activesuspensions.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.views.ActiveSuspensions = Marionette.View.extend({
    template: function(data) {
      return svs.spelpaus.templates.activesuspensions(data);
    },
    regions: {
      activeSuspensionsListRegion: '#activeSuspensionsListRegion'
    },
    behaviors: {
      ServerSideRendering: {
        regionSetup: function() {
          return {
            activeSuspensionsListRegion: {
              view: svs.spelpaus.views.ActiveSuspensionsList,
              options: {
                collection: this.model.get('activeSuspensions')
              }
            }
          };
        }
      }
    },
    initialize: function() {
      this.listenTo(this.model.get('activeSuspensions'), 'add', this.renderIfFirst);
    },
    renderIfFirst: function() {
      if (this.model.get('activeSuspensions').size() === 1) {
        this.render();
      }
    }
  });
})(Backbone, _, svs);

 })(window);